import { cn } from "@omni/utils/styles";

import { H1 } from "@/components/General/Heading/h1";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type SearchTitleComponentProps = {
    query: string;
};

const SearchTitleComponent = ({ query }: SearchTitleComponentProps) => {
    const { t } = useGranite();

    return (
        <H1 className={"heading-1"}>
            {t("search.results.title")}{" "}
            {query !== "" && (
                <span className={cn("tw:font-bold")}>
                    &laquo;{query}&raquo;
                </span>
            )}
        </H1>
    );
};

export { SearchTitleComponent };
